// extracted by mini-css-extract-plugin
export default {"container":"PreviewDocumentModal_container__soQ7W","iframe":"PreviewDocumentModal_iframe__f6sIn"};